import { createAction, handleActions } from 'redux-actions';
import { takeLatest, takeEvery } from 'redux-saga/effects';
import * as apiStatistics from 'apiSaga/apiStatistics';
import createRequestSaga from 'apiSaga/createRequestSaga';

/***** 액션 타입 선언 *****/

// 0. Response 초기화
const INIT_STATISTICS_RESP = 'statistics/INIT_STATISTICS_RESP';
const INIT_STATISTICS_LIST_RESP = 'statistics/INIT_STATISTICS_LIST_RESP';
const INIT_DOCUMENT_FILE_DOWNLOAD_RESP = 'statistics/INIT_DOCUMENT_FILE_DOWNLOAD_RESP';

// 1. 통계 데이터 요청
const GET_STATISTICS_LIST = 'statistics/GET_STATISTICS_LIST';
const GET_STATISTICS_LIST_SUCCESS = 'statistics/GET_STATISTICS_LIST_SUCCESS';
const GET_STATISTICS_LIST_FAILURE = 'statistics/GET_STATISTICS_LIST_FAILURE';
// 2. 참고문서 다운로드
const GET_DOCUMENT_FILE_DOWNLOAD = 'statistics/GET_DOCUMENT_FILE_DOWNLOAD';
const GET_DOCUMENT_FILE_DOWNLOAD_SUCCESS = 'statistics/GET_DOCUMENT_FILE_DOWNLOAD_SUCCESS';
const GET_DOCUMENT_FILE_DOWNLOAD_FAILURE = 'statistics/GET_DOCUMENT_FILE_DOWNLOAD_FAILURE';

// 0. Response 초기화
export const initStatisticsResp = createAction(INIT_STATISTICS_RESP);
export const initStatisticsListResp = createAction(INIT_STATISTICS_LIST_RESP);
export const initDocumentFileDownloadResp = createAction(INIT_DOCUMENT_FILE_DOWNLOAD_RESP);

// 1. 통계 데이터 요청
export const getStatisticsList = createAction(GET_STATISTICS_LIST, (reqParam) => reqParam);
// 2. 참고문서 다운로드
export const getDocumentFileDownload = createAction(GET_DOCUMENT_FILE_DOWNLOAD, (reqParam) => reqParam);

const getStatisticsListSaga = createRequestSaga(GET_STATISTICS_LIST, apiStatistics.getStatisticsList);
const getDocumentFileDownloadSaga = createRequestSaga(
  GET_DOCUMENT_FILE_DOWNLOAD,
  apiStatistics.getDocumentFileDownload
);

export function* apiStatisticsSaga() {
  yield takeEvery(GET_STATISTICS_LIST, getStatisticsListSaga);
  yield takeEvery(GET_DOCUMENT_FILE_DOWNLOAD, getDocumentFileDownloadSaga);
}

// 초기 상태를 선언
// 요청의 로딩 중 상태는 loading 객체에서 관리
const initialState = {
  getStatisticsListResp: null,
  getDocumentFileDownloadResp: null,
};

const apiStatisticsResp = handleActions(
  {
    // 0. Response 초기화
    [INIT_STATISTICS_RESP]: (state, action) => ({
      getStatisticsResp: null,
      getStatisticsListResp: null,
    }),
    [INIT_STATISTICS_LIST_RESP]: (state, action) => ({
      getStatisticsListResp: null,
    }),
    [INIT_DOCUMENT_FILE_DOWNLOAD_RESP]: (state, action) => ({
      getDocumentFileDownloadResp: null,
    }),
    // 1. 통계 데이터 요청
    [GET_STATISTICS_LIST_SUCCESS]: (state, action) => ({
      ...state,
      getStatisticsListResp: action.payload,
    }),
    [GET_STATISTICS_LIST_FAILURE]: (state, action) => ({
      ...state,
      getStatisticsListResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
    // 2. 참고문서 다운로드
    [GET_DOCUMENT_FILE_DOWNLOAD_SUCCESS]: (state, action) => ({
      ...state,
      getDocumentFileDownloadResp: { data: action.payload, headers: action.headers },
    }),
    [GET_DOCUMENT_FILE_DOWNLOAD_FAILURE]: (state, action) => ({
      ...state,
      getDocumentFileDownloadResp: {
        code: 'E999',
        message: action.payload,
      },
    }),
  },
  initialState
);

export default apiStatisticsResp;
